import { useEffect, useState } from 'react'
import { CalendarClock } from 'lucide-react'
import { kassaAPI } from '@/lib/api'

export default function KassaEventBadge({ compact = false }) {
  const [event, setEvent] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true
    if (!localStorage.getItem('auth_token')) return
    kassaAPI.getActiveEvent()
      .then(res => { if (alive) setEvent(res.data?.event) })
      .catch(() => { if (alive) setFailed(true) })
    return () => { alive = false }
  }, [])

  if (failed || !event) return null

  return (
    <div className={compact
      ? 'flex items-center justify-center px-2 py-1.5 gap-1.5 text-neon-blue'
      : 'flex items-center gap-2 px-3 py-1.5 text-xs rounded-md bg-neon-blue/10 text-neon-blue border border-neon-blue/20'}
      title={compact ? `Actief event: ${event.name}` : undefined}
    >
      <CalendarClock className="h-3.5 w-3.5 shrink-0" />
      {!compact && <span className="truncate">{event.name}</span>}
    </div>
  )
}
